import { initializeScratchOffer } from './proda-scratch-offer.js';
import { rememberOfferCompletion } from './proda-capture-client.js';
const consumerSurface = document.body?.dataset.prodaSurface === 'consumer';
const homeSurface = document.body?.dataset.templateName === 'index';
const legalSurface = document.body?.dataset.prodaLegalSurface === 'true' || document.body?.dataset.templateName === 'policy' || ['data-sharing-opt-out', 'consumer-health-data-privacy-policy'].includes(document.body?.dataset.pageHandle);
function protectCurrentNutritionClaimsInInstagramFeed() {
  const blockedPosts = new Map();
  let resizeFrame = 0;

  const removeBlockedPosts = () => {
    for (const caption of document.querySelectorAll('.instafeed-caption')) {
      if (!/\b3g\s+(?:of\s+)?fiber\b/i.test(caption.textContent || '')) continue;

      const modal = caption.closest('.instafeed-lightbox');
      const modalId = modal?.id?.trim();
      if (!modalId || blockedPosts.has(modalId)) continue;

      blockedPosts.set(modalId, {
        previousId: modal.querySelector('.instafeed-new-arrow.prev')?.dataset.instafeedOpenId || '',
        nextId: modal.querySelector('.instafeed-new-arrow.next')?.dataset.instafeedOpenId || '',
      });
    }

    let removedTile = false;
    for (const [modalId, neighbors] of blockedPosts) {
      const safeId = window.CSS?.escape ? window.CSS.escape(modalId) : modalId.replace(/[^a-zA-Z0-9_-]/g, '');

      if (neighbors.nextId) {
        for (const arrow of document.querySelectorAll(
          `.instafeed-new-arrow.next[data-instafeed-open-id="${safeId}"]`
        )) {
          arrow.dataset.instafeedOpenId = neighbors.nextId;
        }
      }

      if (neighbors.previousId) {
        for (const arrow of document.querySelectorAll(
          `.instafeed-new-arrow.prev[data-instafeed-open-id="${safeId}"]`
        )) {
          arrow.dataset.instafeedOpenId = neighbors.previousId;
        }
      }

      for (const opener of document.querySelectorAll(`[data-instafeed-open-id="${safeId}"]`)) {
        const tile = opener.closest('.instafeed-new-layout-item');
        if (!tile) continue;
        tile.remove();
        removedTile = true;
      }

      document.getElementById(modalId)?.remove();
    }

    if (removedTile) {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    }
  };

  const instagramObserver = new MutationObserver(removeBlockedPosts);
  instagramObserver.observe(document.body, { childList: true, subtree: true });
  removeBlockedPosts();
}


if (consumerSurface && !legalSurface) {
  if (homeSurface) protectCurrentNutritionClaimsInInstagramFeed();
  initializeScratchOffer();
  // The dedicated signed offer remains its own service. Observe only its confirmed UI state.
  const observeSignedCompletion = () => {
    const signedOffer = document.querySelector('.proda-social-offer');
    if (!signedOffer || signedOffer.dataset.captureObserved) return;
    signedOffer.dataset.captureObserved = 'true';
    const recordCompletion = () => { if (signedOffer.dataset.step === 'complete') rememberOfferCompletion(); };
    new MutationObserver(recordCompletion).observe(signedOffer, { attributes: true, attributeFilter: ['data-step'] });
    recordCompletion();
  };
  observeSignedCompletion();
  document.addEventListener('DOMContentLoaded', observeSignedCompletion, { once: true });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest('footer a[href="#"]')) return;
    event.preventDefault();
    const page = document.querySelector('.page-wrapper');
    const scrolls = page instanceof HTMLElement && page.scrollHeight > page.clientHeight + 1 && ['auto', 'scroll'].includes(getComputedStyle(page).overflowY);
    (scrolls ? page : window).scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
}
// Preserve scroll recovery around the native embed without opening a second collector.
const restoreScroll = () => {
  if (document.querySelector('[data-proda-offer-fallback][open]')) return;
  const nativeOpen = [...document.querySelectorAll('[role="dialog"][data-kl-scroll-locking-modal="true"]')].some(node => getComputedStyle(node).display !== 'none' && node.getBoundingClientRect().height > 0);
  if (!legalSurface && nativeOpen) return;
  document.body.classList.remove('klaviyo-prevent-body-scrolling');
  if (document.body.style.overflow === 'hidden') document.body.style.removeProperty('overflow');
};
window.addEventListener('klaviyoForms', () => window.setTimeout(restoreScroll, 0));
document.querySelector('[data-proda-offer-fallback]')?.addEventListener('close', restoreScroll);
if (legalSurface) restoreScroll();
